const init = (options) => {
    const navButton = document.querySelector('.js-menu-button');
    const navElement = document.querySelector('.js-main-header');
    const subNavigation = document.querySelector('.js-sub-navigation');
    const htmlElement = document.querySelector('html');

    // toggle classes when menu button is clicked
    function toggleAttributes() {
        const isOpen = navElement.getAttribute('data-is-open') === 'true';
        const isLoggedIn = navElement.getAttribute('data-logged-in') === 'true';

        if (!isOpen) {
            // Safari can't animate height to auto, so pass the content height to the CSS
            navElement.style.setProperty(
                '--dropdown-height',
                `${subNavigation.scrollHeight}px`
            );
        }
        navElement.setAttribute('data-is-open', isOpen ? 'false' : 'true');

        if (isOpen) {
            navButton.blur();
        }
        // When the user is logged-in the overlay is full-screen, so scrolling is disabled
        if (isLoggedIn) {
            htmlElement.classList.toggle('has-active-overlay');
        }
    }

    navButton?.addEventListener('click', toggleAttributes);
};

export default {
    init,
};
